exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".AppFooter-default-yythP{position:absolute;bottom:0;left:0;right:0;margin-top:20px;border-top:1px solid #dadada;background:#fff;text-align:center}.AppFooter-default-yythP a{display:inline-block;color:#b0bec5}.AppFooter-container-1s01E a{padding:10px 0}.AppFooter-side-gvFW7{float:right}.AppFooter-side-gvFW7 a{padding:20px 0 20px 10px}", ""]);

// exports
exports.locals = {
	"default": "AppFooter-default-yythP",
	"container": "AppFooter-container-1s01E",
	"side": "AppFooter-side-gvFW7"
};


//////////////////
// WEBPACK FOOTER
// ./~/css-loader?localIdentName=[name]-[local]-[hash:base64:5]!./~/autoprefixer-loader!./~/less-loader!./lib/app/components/AppFooter.less
// module id = 1598
// module chunks = 0